{
 "version": 1,
 "name": "World edits",
 "assets": [
  {
   "id": "hc-gacha",
   "name": "Hotel Corner gacha machine",
   "prompt": "amber capsule machine",
   "recipe": {
    "family": "capsule-machine",
    "seed": 4412,
    "accent": "amber",
    "material": "metal",
    "width": 34,
    "height": 62,
    "wear": 25,
    "glow": 60,
    "detail": 65,
    "label": "TOYS"
   },
   "width": 96,
   "height": 112,
   "ax": 48,
   "ay": 96,
   "box": [
    31,
    29,
    43,
    76
   ],
   "pixels": "A2J30A13J30A13J30A2K5A6J30A2K5A6J30A2K5A4B34K5A4BJI31BK5A4BJI31BK5A4BJIB28I2BK5A4BJIB28I2BK5A4BJIB2H5B2H3B2HB3HB2H4B3I2BK5A4BJIB4HB3HB3HB2HBHB2HB3KB3I2BK5A4BJIB4HB3HB3HB3HB4H3B4I2BK5A4BJIB4HB3HB3HB3HB7HB3I2BK5A4BJIB4HB3HB3HB3HB7HB3I2BK5A4BJIB4HB4H3B4HB3H4B4I2BK5A4BJIB28I2BK5A4BJI31BK5A4BJI31BK5A4BJI31BK5A4BJI31BK5A4BJI2J26I3BK5A4BJI2JQ24JI3BK5A4BJI2JQ15HQ8JI3BK5A4BJI2JQ8HQ4H5Q6JI3BK5A4BJI2JQ6H5Q2H5Q6JI3BK5A4BJI2JQ6H5QHY5HQ5JI3BK5A4BJI2JQ5HY4EHQH5Q6JI3BK5A4BJI2JQ5H3E5H5Q6JI3BK5A4BJI2JQ5H3E5QH2Q8JI3BK5A4BJI2JQ4HY2EY5EH3Q3GQ3JI3BK5A4BJI2JQ2F3H3E5H4QG5QJI3BK5A4BJI2JQ2F3H3E5Y4HG5QJI3BK5A4BJI2JQFY5HFQEQH5GY5GJI3BK5A4BJI2JQ2F5Q4EH5QG5QJI3BK5A4BJI2JQ2F3HFQ2E5H3QEG4QJI3BK5A4BJI2JQ3H5QE5H2E5Q3JI3BK5A4BJI2JQ3H5EY3BYEYEKE3Q3JI3BK5A4BJI2JQ2HY5HB7Y5EQ2JI3BK5A4BJI2JQ3H5B4JB4E4Q3JI3BK5A4BJI2JQ3H4B2J7B2E3Q3JI3BK5A4BJI2JQ5HB2J9B2Q5JI3BK5A4BJI2JQ6B2J9B2Q5JI3BK5A4BJI2JQ6H12BQ5JI3BK5A4BJI2J6BH12B2J5I3BK5A4BJI9B2J9B2I9BK5A4BJI9B2J9B2I9BK5A4BJI9B2J9B2I9BK5A4BJI10B2J7B2I10BK5A4BJI11B4JB4I11BK5A4BJI12B7I12BK5A4BJI15BI15BK5A4BJI31BK5A4BJI31BK5A4BJI31BK5A4BJI31BK5A4BJI31BK5A4BJI3B24IKI2BK5A4BJI3B24I4BK5A4BJI3B24I4BK5A4BJI3B24I4BK5A4BJI3B24I4BK5A4BJI3B24I4BK5A4BJI31BK5A4BJI31BK5A4BJI31BK5A4B34K5A7B6f16B6f8A7B6f16B6f10A5f39A3f41A3f39A5f37A8f33A14f25A30fA20"
  },
  {
   "id": "hc-planter",
   "name": "Hotel Corner planter",
   "prompt": "small planter with bush",
   "recipe": {
    "family": "planter",
    "seed": 811,
    "accent": "amber",
    "material": "concrete",
    "width": 40,
    "height": 44,
    "wear": 25,
    "glow": 55,
    "detail": 65,
    "label": ""
   },
   "width": 96,
   "height": 112,
   "ax": 48,
   "ay": 96,
   "box": [
    25,
    45,
    53,
    60
   ],
   "pixels": "A7UA13UA35U7A7U7A31U2VU6A5U2VU6A30V5U4A5V5U4A29V7U4A3V7U4A27UV7U5AUV7U5A26UV7U5AUV7U5A26V9U4AV9U4A26UV7U5AUV7U5A26UV7U5AUV7U5A25U2V7UYU5V7U6A25U2V5U6AU2V5U7A25U4VU8AU4VU12A3UA18U25VU12A15U23V5U4VU6A14U11VU10V7UV5U4A15U8V5U8V14U4A15U6V7U7V6UV7U5A14U6V7U6V7UV7U5A15U5V7U7V15U4A18UV9U6V6UV7U5A19UV7U7V6UV7U5A19UV7U5AU2V4U2V7U6A17U2V7U10VU4V5U6A19U2V5U6AU11VU8A19U4VU8AU11NU8A19U13AU20A19U13AWU19A16M3U13M2WU17A17M4U11M3WU16MA17M4WU9M4WMU15MA2N3YKA10M4WU9M4WM4UMWMU7M2A2N3KNA10M4WMU7M5WM6WM4UMWM3A2NK2N2A8B6WB4UBWB6WB6WB6WB5KN4A8BML4WL6WL6WL6WL6WL4BN5A8BML37BN5A8BML37BN5A8BML37BN5A8BML37BN5A8BML37BN5A8BML24YL12BN5A8BML37BN5A8BML37BN5A8BML37BN5A8BML37BN5A8BML37BN5A8BML37BN5A8BML37BN5A8BML37BN5A8BML37BN5A8B40N5A11B6f22B6f8A11B6f22B6f10A8f47A5f49A5f47A8f43A12f39A19f29A38fA24"
  },
  {
   "id": "hc-planter-s",
   "name": "Hotel Corner small planter",
   "prompt": "small planter with bush",
   "recipe": {
    "family": "planter",
    "seed": 812,
    "accent": "amber",
    "material": "concrete",
    "width": 24,
    "height": 36,
    "wear": 25,
    "glow": 55,
    "detail": 65,
    "label": ""
   },
   "width": 96,
   "height": 112,
   "ax": 48,
   "ay": 96,
   "box": [
    33,
    46,
    35,
    59
   ],
   "pixels": "A21UA31U7A27U2VU6A26V5U4A25V7U4A23UV7U5A22UV7U5A14UA7V9U4A11U7A4UV7U5A10U2VU6A3UV7U5A10V5U4A2U2V7U6A8V7U8V5U6A8UV7U3VU6VU8A8UV7UV5U13A8V14U13A8UV6UV6U13A8UV6UV7U11A8U2V15U9A10U2V5UV7U10A10U4VU3V7U9A11U8V7U6WA13U9V5U6AWA13U11VU8AWA14U19AWA15U18AWA15U18AWA16U16M2WM2A15M2UWMU9M3WM2A15M3WMU9M4WMA2N5BA7M4WMU4NU2M5WMA2N4KNA7M4WM4UMWM6WMA2N2K2N2A7M4WM6WM6WMA2NKN4A5B6WB6WB6WB3KN5A5BML4WL6WL6WL2BN6A5BML21BN6A5BML21BN6A5BML21BN6A5BML21BN6A5BML21BN6A5BML21BN6A5BML21BN6A5BML21BN6A5BML21BN6A5BML21BN6A5BML21BN6A5BML21BN6A5BML21BN6A5BML21BN6A5BML21BN6A5B24N6A8B6f6B6f8A9B6f6B6f9A9f27A7f29A7f27A9f25A11f23A15f17A26fA14"
  },
  {
   "id": "hc-bags",
   "name": "Hotel Corner trash bags",
   "prompt": "trash bags",
   "recipe": {
    "family": "trash-bags",
    "seed": 905,
    "accent": "cyan",
    "material": "metal",
    "width": 42,
    "height": 36,
    "wear": 50,
    "glow": 55,
    "detail": 65,
    "label": ""
   },
   "width": 96,
   "height": 112,
   "ax": 48,
   "ay": 96,
   "box": [
    27,
    67,
    52,
    38
   ],
   "pixels": "A8D4A48D4A48D4A7D4A36F6A6D4A36F6BA5D4A34BD7B3A2F6A32BD9B3AF6BA5D4A21BD11B2D7B3A3D4A21D6KD5BD9B3A2D4A20BD11BD11B3F6A19D11BD13B2F6B2A16BD10CBD12B2D7B4A14BD10BD10CDBD11B3A13BD10BD11BD13B3A12BD10BD11BD9CD3B3A12D11BD10BD11CD3B3A10B2D2KD18BD11CD3B3A11BD3KD5B2D2KD7BD12CD2B3A11BD3KD6BD3KD20CD2B2A11BD4KD5BD3KD5B2D2KD10CDB4A10BD4KD5BD4KD5BD3KD10CB3A11B2D4KD4B2D3KD5BD4KD9CB3A12BYD3KD4B2D4KD4B2D3KD9BCB2A12B2D4KD4B2D3KD4B2D4KD8B4A13B2D3KD4B3D3KD4B2D4KD6B4A14B3D7B4D7B4D7B6A15B5DB10DB10DB8A17B34A20B7f4B7f3B9f5A16f4Bf10Bf10Bf14A9f45A5f49A2f51A2f49A5f45A9f41A16f31A36fA25"
  },
  {
   "id": "hc-board",
   "name": "Hotel Corner menu board",
   "prompt": "pink sandwich board",
   "recipe": {
    "family": "sandwich-board",
    "seed": 3071,
    "accent": "pink",
    "material": "metal",
    "width": 37,
    "height": 36,
    "wear": 25,
    "glow": 60,
    "detail": 65,
    "label": "MENU"
   },
   "width": 96,
   "height": 112,
   "ax": 48,
   "ay": 96,
   "box": [
    30,
    60,
    46,
    45
   ],
   "pixels": "S37A9S27YS9A9S37A9S3R31S3A9S3RB29RS3A9S3RB29RS3A9S3RB29RS3A9S3RB29RS3A9S3RB3GB3GBG5BGB3GBGB3GB3RS3A9S3RB3G2BG2BGB5G2B2GBGB3GB3RS3A9S3RB3GBGBGBG4B2GBGBGBGB3GB3RS3A9S3RB3GB3GBGB5GB2G2BGB3GB3RS3A9S3RB3GB3GBGB5GB3GBGB3GB3RS3A9S3RB3GB3GBG5BGB3GB2G3B4RS3A9S3RB29RS3A9S3RB29RS3A9S3RB14KB14RS3A9S3RB29RS3TA8S3RB29RS3TA8S3RB29RS3TA8S3RB29RS3ATA7S3RB29RS3ATA7S3RB29RS3ATA7S3RB29RS3ATA7S3RB29RS3A2TA6S3RB29RS3A2TA6S3R31S3A2TA6S37A3TA5S37A3TA5T4S29T4A3TA5T4A29T4A3TA5T4A29T4A4TA4T4A29T4A4TA4T4A29T4A4TA4T4A19fA9T4A4TA4T4A6f23T4A5TA3T4A2f27T4f4ATA6f41A4f43A2f45A2f43A4f41A8f35A15f27A32fA22"
  },
  {
   "id": "hc-drain",
   "name": "Hotel Corner storm drain",
   "prompt": "storm drain",
   "recipe": {
    "family": "storm-drain",
    "seed": 77,
    "accent": "amber",
    "material": "metal",
    "width": 42,
    "height": 36,
    "wear": 25,
    "glow": 55,
    "detail": 65,
    "label": ""
   },
   "width": 96,
   "height": 112,
   "ax": 48,
   "ay": 96,
   "box": [
    27,
    78,
    42,
    18
   ],
   "pixels": "B44J38B4K38B4K2B2JKB2JK3B2JK2B2JKB2JK3B2JK3B2JK2B4K2B2JKB2JK3B2JK2B2JKB2JK3B2JK3B2JK2B4K2B2JKB2JK3B2JK2B2JKB2JK3B2JK3B2JK2B4K2B2JKB2JK3B2JK2B2JKB2JK3B2JK3B2JK2B4K2B2JKB2JK3B2JK2B2JKB2JK3B2JK3B2JK2B4K2B2JKB2JK3B2JK2B2JKB2JK3B2JK3B2JK2B4K2B2JKB2JK3B2JK2B2JKB2JK3B2JK3B2JK2B4K2B2JKB2JK3B2JK2B2JKB2JK3B2JK3B2JK2B4K2B2JKB2JK3B2JK2B2JKB2JK3B2JK3B2JK2B4K2B2JKB2JK3B2JK2B2JKB2JK3B2JK3B2JK2B4K2B2JKB2JK3B2JK2B2JKB2JK3B2JK3B2JK2B4K2B2JKB2JK3B2JK2B2JKB2JK3B2JK3B2JK2B4K38B86"
  }
 ],
 "props": [
  {
   "id": "hc-board-1",
   "assetId": "hc-board",
   "x": 83.1,
   "y": 28.4
  },
  {
   "id": "hc-drain-1",
   "assetId": "hc-drain",
   "x": 89.6,
   "y": 29.8
  },
  {
   "id": "hc-gacha-1",
   "assetId": "hc-gacha",
   "x": 95.9,
   "y": 28.3
  },
  {
   "id": "hc-bags-1",
   "assetId": "hc-bags",
   "x": 98.4,
   "y": 28.3
  },
  {
   "id": "hc-planter-1",
   "assetId": "hc-planter",
   "x": 100.6,
   "y": 27.8
  },
  {
   "id": "hc-planter-2",
   "assetId": "hc-planter-s",
   "x": 81.45,
   "y": 27.8
  }
 ]
}
